import axiosInstance from './axiosInstance';
import { IPdfBlockTemplate } from '../types/pdfBlockTypes';

const API_BASE = '/api/pdf-blocks';

/**
 * Get all PDF block templates
 */
export async function getPdfBlocks(type?: 'products' | 'wine'): Promise<IPdfBlockTemplate[]> {
  const params = type ? { type } : {};
  const { data } = await axiosInstance.get(API_BASE, { params });
  return data;
}

/**
 * Get single PDF block template by ID
 */
export async function getPdfBlock(id: string): Promise<IPdfBlockTemplate> {
  const { data } = await axiosInstance.get(`${API_BASE}/${id}`);
  return data;
}

/**
 * Create new PDF block template
 */
export async function createPdfBlock(block: Omit<IPdfBlockTemplate, '_id'>): Promise<IPdfBlockTemplate> {
  const { data } = await axiosInstance.post(API_BASE, block);
  return data;
}

/**
 * Update PDF block template
 */
export async function updatePdfBlock(id: string, block: Partial<IPdfBlockTemplate>): Promise<IPdfBlockTemplate> {
  const { data } = await axiosInstance.patch(`${API_BASE}/${id}`, block);
  return data;
}

/**
 * Delete PDF block template
 */
export async function deletePdfBlock(id: string): Promise<void> {
  await axiosInstance.delete(`${API_BASE}/${id}`);
}

/**
 * Duplicate a block template
 */
export async function duplicatePdfBlock(id: string): Promise<IPdfBlockTemplate> {
  const { data } = await axiosInstance.post(`${API_BASE}/${id}/duplicate`);
  return data;
}
